<template>
	<div>
		<!-- Header -->
		<div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
			<b-container>
				<div class="header-body text-center mb-7">
					<b-row class="justify-content-center">
						<b-col xl="5" lg="6" md="8" class="px-5">
							<h1 class="text-white">热搜引擎-专业版</h1>
							<p class="text-lead text-white">微博历史热搜、微博文娱热搜、抖音热榜、头条热榜、知乎热榜、百度热搜一网打尽，更多数据正在接入中</p>
						</b-col>
					</b-row>
				</div>
			</b-container>
			<div class="separator separator-bottom separator-skew zindex-100">
				<svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
					xmlns="http://www.w3.org/2000/svg">
					<polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
				</svg>
			</div>
		</div>
		<!-- Page content -->
		<b-container class="mt--8 pb-5">
			<b-row class="justify-content-center">
				<b-col lg="5" md="7">
					<b-card no-body class="bg-secondary border-0 mb-0">
						<b-card-body class="px-lg-5 py-lg-5">

							<div id="wxqrdiv">
								<h5 class="card-title">当前【微信二维码扫码登录】切换为<span @click="phonepassordLoginView()"
										style="color: red;cursor: pointer;">手机号+密码</span>登录</h5>
								<div style="width:50%;margin: 0 auto;" id="wxLoginQr"></div>
							</div>

							<div id="phone-password-login" style="display: none;">
								<h5 class="card-title">当前【手机号+密码登录】推荐<span @click="qrLoginView()"
										style="color: red;cursor: pointer;">微信二维码扫码</span>登录</h5>
								<validation-observer v-slot="{handleSubmit}" ref="formValidator">
									<b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
										<base-input alternative class="mb-3" name="Email"
											prepend-icon="ni ni-mobile-button" placeholder="输入登录账号"
											v-model="model.email">
										</base-input>
										<base-input alternative class="mb-3" name="Password"
											prepend-icon="ni ni-lock-circle-open" type="password" placeholder="输入密码"
											v-model="model.password">
										</base-input>
										<div class="text-center">
											<base-button type="primary" native-type="submit">登录</base-button>
										</div>
									</b-form>
								</validation-observer>
							</div>

							<div id="bangdingPhone" style="display: none;">
								<div style="text-align: center;">
									即日起该站点停止注册,整体功能已迁移至热搜引擎新网站，请移步热搜引擎新网站体验，感谢支持。
									热搜引擎网站支持更多功能。
									<br />如有任何建议，欢迎在社区反馈。
									<br /><br />
									<el-button  @click="goNew()">跳转到热搜引擎
									</el-button>
								</div>
								<h5 style="display: none;" class="card-title">根据相关法律法规，需要进一步绑定手机号即可使用</h5>
								<validation-observer style="display: none;"  v-slot="{handleSubmit}" ref="formValidator">
									<b-form role="form" @submit.prevent="handleSubmit(bdSubmit)">
										<div style="display: flex;width: 100%;">
											<div style="float: left;width: 54%;">
												<base-input alternative class="mb-3" prepend-icon="ni ni-mobile-button"
													placeholder="手机号" name="Name" v-model="model.bdloginName">
												</base-input>
											</div>
											<div style="float: right;width: 45%;">
												<b-button v-show="show" @click="sendSms()"
													style="margin-left: 5px; width: 100%;">获取验证码
												</b-button>
												<b-button v-show="!show" style="margin-left: 5px; width: 100%;">
													{{count}}s</b-button>
											</div>
										</div>

										<base-input alternative class="mb-3" prepend-icon="ni ni-chat-round"
											placeholder="输入验证码" name="code" v-model="model.bdcode">
										</base-input>

										<base-input id="setPassword" style="display: none;" alternative class="mb-3"
											prepend-icon="ni ni-lock-circle-open" placeholder="请设置密码" type="password"
											name="Password" v-model="model.bdpassword">
										</base-input>

										<base-input id="setPassword1" style="display: none;" alternative class="mb-3"
											prepend-icon="ni ni-lock-circle-open" placeholder="请重新输入密码" type="password"
											name="Password" v-model="model.bdtwoPassword">
										</base-input>

										<div class="text-center">
											<b-button type="submit" variant="primary">绑定并登录</b-button>
										</div>
									</b-form>
								</validation-observer>
							</div>

						</b-card-body>
					</b-card>
					<b-row class="mt-3">
						<b-col cols="6">
							<router-link to="/retrieve" class="text-light"><small>找回密码?</small></router-link>
						</b-col>
						<b-col cols="6" class="text-right">
							<router-link to="/register" class="text-light"><small>创建新的账号</small></router-link>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
	import {
		useRouter
	} from "vue-router";
	import {
		login,
		wxLoginQr,
		wxLoginQrIsLogin,
		sendBdSms,
		bdRegister
	} from "../../api/user.js";
	import {
		fnSetToken,
		fnGetToken,
		fnRemoveToken
	} from '../../util/auth.js'
	import {
		Message,
		Button
	} from 'element-ui'

	const state = {
		token: fnGetToken()
	}

	const mutations = {
		SET_TOKEN: (state, token) => {
			state.token = token
		}
	}
	export default {
		components: {
			[Message.name]: Message,
			[Button.name]: Button
		},
		data() {
			return {
				show: true,
				count: 0,
				openId:'',
				model: {
					email: '',
					password: '',
					bdloginName: '',
					bdcode: '',
					bdpassword: '',
					bdtwoPassword: ''
				}
			};
		},
		mounted() {
			this.qrLoginView()
		},
		methods: {
			goNew() {
				console.log("跳转")
				window.open("https://zhaoyizhe.com/?aff=wlv62z")
			},
			phonepassordLoginView() {
				var t = document.getElementById('wxqrdiv');
				t.style.display = 'none';
				var t = document.getElementById('phone-password-login');
				t.style.display = '';
			},
			qrLoginView() {
				console.log("要出现二维码");
				var t = document.getElementById('wxqrdiv');
				t.style.display = '';
				var t = document.getElementById('phone-password-login'); //选取id为phone-password-login的div元素
				t.style.display = 'none'; // 隐藏选择的元素

				var flagQr = Math.floor(Math.random() * 999995999) + 1000;
				var that = this;
				wxLoginQr(flagQr,null).then(res => {
					document.getElementById('wxLoginQr').innerHTML = "";
					new QRCode(document.getElementById('wxLoginQr'), res.data.data.url);
					// 轮询
					var id = setInterval(function() {
						if ($("#wxqrdiv").is(":hidden")) {
							clearInterval(id)
						}
						wxLoginQrIsLogin(flagQr,res.data.data.ticket).then(isloginRes => {
							console.log(isloginRes)
							if (isloginRes.data.data.status === 2) {
								clearInterval(id)
								console.log(isloginRes)
								if (isloginRes.data.data.token != null) {
									fnSetToken(isloginRes.data.data.token)
									// 跳转到index
									window.location.href = "/"
								} else {
									that.$data.openId=isloginRes.data.data.openId;
									Message.info("首次请绑定手机号~");
									// 跳转到绑定手机号页面
									console.log("弹出绑定手机号的框")
									var t = document.getElementById('bangdingPhone');
									t.style.display = '';
									var t = document.getElementById('wxqrdiv');
									t.style.display = 'none';
									var t = document.getElementById('phone-password-login');
									t.style.display = 'none';
								}
							}
						})
					}, 1000);
				}).catch((err) => {
					console.log(err)
				})
			},
			bdSubmit() {
				var that = this;
				console.log(that.$data.model.bdloginName)
				// 校验验证码不能为空
				if (that.model.bdcode == null || that.model.bdcode == "") {
				  Message.info("验证码为空");
				  return;
				}
				
				if(!$("#setPassword").is(":hidden")||!$("#setPassword1").is(":hidden")){
					if (that.model.bdpassword == null || that.model.bdpassword == "") {
					  Message.info("密码为空");
					  return;
					}
					
					// 校验密码输入是否一致
					if (that.model.bdpassword != that.model.bdtwoPassword) {
					  Message.info("两次密码输入不一致");
					  return;
					}	
				}
				if (that.model.bdloginName == null || that.model.bdloginName == "") {
				  Message.info("手机号不正确");
				  return;
				}	
					
				// 注册并绑定
				bdRegister(that.model.bdloginName, that.model.bdpassword, that.model.bdcode,that.openId).then(res => {
				  if (res.data.code != 1) {
				    Message.info(res.data.message);
				  } else {
				    console.log(res.data.data.token)
				    fnSetToken(res.data.data.token)
				    // 跳转到index
				    window.location.href="/"
				    Message.info("绑定成功，正在登录");
				  }
				}).catch((err) => {
				  console.log(err)
				})
				
			},
			sendSms() {
				var that = this;
				if (that.model.bdloginName == null || that.model.bdloginName == "") {
					Message.info("手机号为空");
					return;
				}

				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
			 	this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}
				// 发送验证码
				sendBdSms(that.model.bdloginName).then(res => {
					console.log(res)
			  if (res.data.code != 1) {
						this.show = true;
						clearInterval(this.timer);
						this.timer = null;
						Message.info("短信发送失败,请核对手机号或联系管理员");
			  } else {
						if (res.data.data.user == null) {
							// 需要设置密码
							var t = document.getElementById('setPassword');
							t.style.display = '';
							var t = document.getElementById('setPassword1');
							t.style.display = '';
						} else {
							var t = document.getElementById('setPassword');
							t.style.display = 'none';
							var t = document.getElementById('setPassword1');
							t.style.display = 'none';
						}
						Message.info("短信发送成功,请查收");
			  }
				}).catch((err) => {
					console.log(err)
				})
			},
			onSubmit() {
				var that = this;
				login(that.$data.model.email, that.$data.model.password).then(res => {
					if (res.data.code != 1) {
						// 登录失败，弹框
						Message.info(res.data.message);
					} else {
						fnSetToken(res.data.data.token)
						// 跳转到index
						window.location.href = "/"
					}
				}).catch((err) => {
					console.log(err)
				})
			}
		}
	};
</script>

<style>
	#wxLoginQr img {
		width: 178px;
	}
</style>
